
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {ServiceStatus} from '../entity/ServiceStatus';
import {FieldModelServiceStatus} from '../entity/ServiceStatus';
import {ServiceStatusDetail} from './ServiceStatusDetail';
import {FieldModelServiceStatusDetail} from './ServiceStatusDetail';

/**
 * ServiceStatusGetResponse struct
 */
class ServiceStatusGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!ServiceStatus=} status
   * @param {!Set=} details
   * @constructor
   */
  constructor (parent = new Response(), status = new ServiceStatus(), details = new Set()) {
    super()
    super.copy(parent)
    this.Status = status
    this.Details = details
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ServiceStatusGetResponse}
   * @param {!ServiceStatusGetResponse} other Other struct
   * @returns {!ServiceStatusGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Status != null) {
      this.Status = ServiceStatus.fromObject(other.Status)
    } else {
      this.Status = null
    }
    if (other.Details != null) {
      this.Details = new Set()
      for (let item of other.Details) {
        if (item != null) {
          let tempItem
          tempItem = ServiceStatusDetail.fromObject(item)
          this.Details.add(tempItem)
        } else {
          this.Details.add(null)
        }
      }
    } else {
      this.Details = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ServiceStatusGetResponse}
   * @returns {!ServiceStatusGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ServiceStatusGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ServiceStatusGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ServiceStatusGetResponse}
   * @param {!ServiceStatusGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ServiceStatusGetResponse)) {
      throw new TypeError('Instance of ServiceStatusGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ServiceStatusGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Status: ((this.Status != null) ? this.Status : null),
      Details: ((this.Details != null) ? Array.from(this.Details, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ServiceStatusGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ServiceStatusGetResponse} other Object value
   * @returns {!ServiceStatusGetResponse} Created struct
   */
  static fromObject (other) {
    return new ServiceStatusGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ServiceStatusGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ServiceStatusGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ServiceStatusGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 12007
  }
}

export { ServiceStatusGetResponse };

/**
 * Fast Binary Encoding ServiceStatusGetResponse field model
 */
class FieldModelServiceStatusGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Status = new FieldModelServiceStatus(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Details = new fbe.FieldModelSet(new FieldModelServiceStatusDetail(buffer, this.Status.fbeOffset + this.Status.fbeSize), buffer, this.Status.fbeOffset + this.Status.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Status.fbeSize + this.Details.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Status.fbeExtra + this.Details.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelServiceStatusGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 12007
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Status.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Status.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Details.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Details.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Details.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!ServiceStatusGetResponse} fbeValue Default value, defaults is new ServiceStatusGetResponse()
   * @returns {!ServiceStatusGetResponse} ServiceStatusGetResponse value
   */
  get (fbeValue = new ServiceStatusGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!ServiceStatusGetResponse} fbeValue ServiceStatusGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Status.fbeSize) <= fbeStructSize) {
      fbeValue.Status = this.Status.get()
    } else {
      fbeValue.Status = new ServiceStatus()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Details.fbeSize) <= fbeStructSize) {
      this.Details.get(fbeValue.Details)
    } else {
      fbeValue.Details.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Details.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelServiceStatusGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {!ServiceStatusGetResponse} fbeValue ServiceStatusGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelServiceStatusGetResponse}
   * @param {ServiceStatusGetResponse} fbeValue ServiceStatusGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Status.set(fbeValue.Status)
    this.Details.set(fbeValue.Details)
  }
}

export { FieldModelServiceStatusGetResponse };

/**
 * Fast Binary Encoding ServiceStatusGetResponse model
 */
class ServiceStatusGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelServiceStatusGetResponse(this.buffer, 4)
  }

  /**
   * Get the ServiceStatusGetResponse model
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!FieldModelServiceStatusGetResponse} model ServiceStatusGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ServiceStatusGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelServiceStatusGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ServiceStatusGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ServiceStatusGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ServiceStatusGetResponseModel}
   * @param {!ServiceStatusGetResponse} value ServiceStatusGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ServiceStatusGetResponseModel}
   * @param {!ServiceStatusGetResponse} value ServiceStatusGetResponse value, defaults is new ServiceStatusGetResponse()
   * @return {!object} Deserialized ServiceStatusGetResponse value and its size
   */
  deserialize (value = new ServiceStatusGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ServiceStatusGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ServiceStatusGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ServiceStatusGetResponseModel}
   * @param {!number} prev Previous ServiceStatusGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ServiceStatusGetResponseModel };
